// extracted by mini-css-extract-plugin
export default {"selected":"SortSelect_selected__eQK-i"};